import React from "react";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import loader from "../../../../assets/images/button-loader.svg"
import { useParams } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import Loader from "../../../../components/Loader/Loader";
import { Label } from "../../../../components/Label/Label";
import TextEditor from "../../../../components/TextEditor/TextEditor";
import { useNavigate } from "react-router-dom";

const InvestorCharter = () => {
    const {
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const [isLoading, setLoading] = useState(false);
    const [ShowLoader, setShowLoader] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [previousData, setpreviousData] = useState("");
    const [editorData, setEditorData] = useState<any>()
    const navigate = useNavigate();

    let { id } = useParams();

    useEffect(() => {
        getDetail();
    }, []);

    const onSave = (data: any) => {
        if (!editorData && !previousData) {
            setShowWarningModal(true);
            setWarningMessage("Please Enter Charter")
            return;
        }
        data.charter = editorData
        setLoading(true);
        WebService.putAPI({
            action: `/v2/InvestorCharter/Update`,
            body: data,
        })
            .then((res: any) => {
                setLoading(false);
                setShowSucessModal(true);
                setSucessMessage(res.message);
            })
            .catch((e) => {
                setLoading(false);
                setShowWarningModal(true);
            });
    };

    const getDetail = () => {
        setLoading(true);
        WebService.postAPI({
            action: `/v2/InvestorCharter/GetDetail`,
        })
            .then((res: any) => {
                setLoading(false);
                reset(res.result);
                setpreviousData(res.result.charter)
            })
            .catch((e) => {
                setLoading(false);
                // setShowWarningModal(true);
                // setWarningMessage(e.response.data.message)
            });
    }

    const currentValue = (data: any) => {
        setEditorData(data)
    };

    const goBack = () => {
        navigate("/master/website-compliance/investor-charter");
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />

            <Loader show={ShowLoader} />
            <div className="page-content-wraper">
                <form onSubmit={handleSubmit(onSave)}>
                    <div className="grid grid-cols-2 gap-4 mb-3">
                        <div>
                            <h1 className="page-title">Investor Charters</h1>
                        </div>
                    </div>
                    <div className="rounded-xl bg-white p-4 mb-4">
                        <div className="col-12 form-group">
                            <Label title="Charter" type="BOLD" />
                            <div className="mt-5">
                                <TextEditor data={previousData} editedData={currentValue} type={"NORMAL"} />
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-4">
                        <button
                            type="button"
                            className="btn btn-white mr-3"
                            onClick={goBack}>
                            Cancel
                        </button>
                        <button className="btn btn-brand" type="submit">
                            {isLoading && <img src={loader} className='spinner' />}
                            Save
                        </button>
                    </div>
                </form>
            </div>

        </>
    )
}
export default InvestorCharter;